export default "__VITE_ASSET__CGcGP7VX__"